var map = {
	"./Acquisition of Business through an Asset Deal.pdf": [
		5547,
		5547
	],
	"./Acquisition of shares of an unlisted company.pdf": [
		774,
		774
	],
	"./Formation of a Limited Liability Partnership in India.pdf": [
		6185,
		6185
	],
	"./Formation of a Private Limited Company in India.pdf": [
		8126,
		8126
	],
	"./Preferential Allotment and Rights Issue.pdf": [
		649,
		649
	],
	"./Setting up Branch Office in India.pdf": [
		2926,
		2926
	],
	"./Setting up a Liaison Office in India.pdf": [
		9890,
		9890
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6131;
module.exports = webpackAsyncContext;